define((require) => {
    "use strict";

    const _     = require("underscore");
    const Scene = require("shared/ui/experience/Scene");

    /**
     * Model for the background scene.
     *
     * @class BackgroundScene
     * @constructor
     */
    return Scene.extend({
        defaults: _.defaults({
            sceneNumber: "background"
        }, Scene.prototype.defaults)
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/BackgroundScene.js